import React from 'react';
import PropTypes from 'prop-types';
import { areEqual } from 'react-window';
import { formatClassNames } from '../../../../helpers';

// eslint-disable-next-line react/display-name
const RenderWindowOption = React.memo(({ data, index, style }) => {
  const { menuOptions, focusedOptionKey, formatOptionLabel } = data;
  const option = menuOptions[index];
  const classes = formatClassNames(['option', (option.value === focusedOptionKey) && 'focused',
    option.isSelected && 'selected', option.fixed && 'fixed']);

  return (
    <div
      style={style}
      {...option.innerProps}
      className={classes}
    >
      {formatOptionLabel(option.data)}
    </div>
  );
}, areEqual);

RenderWindowOption.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  style: PropTypes.object,
};

export default RenderWindowOption;